<div>
  <div [hidden]="!loading" class="spinner h-75">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <app-table [rows]="rows" [columns]="columns" [actions]="tableActions" (action)="onAction($event)"></app-table>
  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination *ngIf="totalCount > currentSize" [totalItems]="totalCount" [(currentPage)]="page" (change)="onPageChange($event)"
        [pageSize]="currentSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right mt-10">
      <span class="pagination-count">Showing {{ rows.length }} of {{ totalCount }} results</span>
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === currentSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
